<template>
  <div>
    <div class="hero mobiletrading-bg">
      <div class="inner">
        <h1 v-html="$t('mobileTradingTerminalPage.text1')"></h1>
        <h5 class="subtitle">
          {{$t('mobileTradingTerminalPage.text2')}}
        </h5>
      </div>
    </div>

    <section class="">
      <div class="section-inner">
				<img class="article-image" src="@/assets/images/mobileTrading-image1.png" alt="">
        <div class="article-container">
          <h2 v-html="$t('mobileTradingTerminalPage.text3')"></h2>
          <p>
            {{$t('mobileTradingTerminalPage.text4')}}
          </p>
        </div>
      </div>
    </section>

		<section class="section3 light-gray">
			<div class="section-inner">
				<h2>{{$t('mobileTradingTerminalPage.text5')}}</h2>
				<div class="spacer"></div>
				<div class="col4-grid text-left">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/mobileTrading-icon1.svg" alt="" /></div>
            <h5>{{$t('mobileTradingTerminalPage.text6')}}</h5>
            <ul class="col-list">
							<li>{{$t('mobileTradingTerminalPage.text7')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text8')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text9')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/mobileTrading-icon2.svg" alt="" /></div>
            <h5>{{$t('mobileTradingTerminalPage.text10')}}</h5>
            <ul class="col-list">
							<li>{{$t('mobileTradingTerminalPage.text11')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text12')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text13')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/mobileTrading-icon3.svg" alt="" /></div>
            <h5>{{$t('mobileTradingTerminalPage.text14')}}</h5>
            <ul class="col-list">
							<li>{{$t('mobileTradingTerminalPage.text15')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text16')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text17')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/mobileTrading-icon4.svg" alt="" /></div>
            <h5>{{$t('mobileTradingTerminalPage.text18')}}</h5>
            <ul class="col-list">
							<li>{{$t('mobileTradingTerminalPage.text19')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text20')}}</li>
							<li>{{$t('mobileTradingTerminalPage.text21')}}</li>
						</ul>
          </div>
        </div>
			</div>
		</section>
    
		<section class="section3">
			<div class="section-inner">
				<h2>{{$t('mobileTradingTerminalPage.text22')}}</h2>
				<div class="spacer"></div>
				<div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/mobileTrading-image2.png" alt=""></div>
            <h5>{{$t('mobileTradingTerminalPage.text23')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/mobileTrading-image3.png" alt=""></div>
            <h5>{{$t('mobileTradingTerminalPage.text24')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img class="device-images" src="@/assets/images/mobileTrading-image4.png" alt=""></div>
            <h5>{{$t('mobileTradingTerminalPage.text25')}}</h5>
          </div>
        </div>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
			</div>
		</section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'MobileTradingTerminal',
	components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
